export default __webpack_public_path__ + "static/fathom-capital-414244b732eac2d2626b2a0558ae8cdf.png";